import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { PasswordRevealModule } from 'Angular/features/components/password-controls/password-reveal/password-reveal.module';
import { ImageModule } from 'Angular/features/directives/image/image.module';

import { PasswordResetComponent } from './password-reset.component';

@NgModule({
    declarations: [PasswordResetComponent],
    exports: [PasswordResetComponent],
    imports: [ImageModule, PasswordRevealModule, FormsModule],
})
export class PasswordResetModule {}
